<div class="PGImportJob">
    @if (!job.time) {
        <h5 class="mb-1">{{ 'pg-import.new-job' | locTranslate }}</h5>
    }
    @if (job.time) {
        <h5 class="mb-1">
            <div class="d-flex justify-content-between align-items-baseline">
                <div>{{ 'pg-import.job' | locTranslate }}</div>
                <div class="PGImportJob-Title-Time">
                    <i class="fa-regular fa-calendar"></i>
                    <span>{{ formatDate(job.time) }}</span>
                    <i class="fa-regular fa-clock"></i>
                    <span>{{ formatTime(job.time) }}</span>
                </div>
            </div>
        </h5>
    }

    <div class="mb-2 d-flex justify-content-between align-items-baseline">
        <div>
            <i class="{{ getImportTypeIcon(job.type) }} me-2"></i>
            <span>{{ 'pg-import.from-' + job.type | locTranslate }}</span>
        </div>
        <div>
            <span>{{ getRealmName(job.realm) }}</span>
        </div>
    </div>

    @if (getEntouranceJob(job); as job) {
        <div>
            <b>{{ 'pg-import.api-url' | locTranslate }}</b>
            <span>{{ getImportInstallationName(job.APIUrl) }}</span>
        </div>
        <div class="PGImportJob-Items">
            <b>{{ 'pg-import.elements' | locTranslate }}</b>
            <span>
                @if (job.items != null) {
                    <span [innerHTML]="getJobItemListDisplay(job.items)"></span>
                }
            </span>
        </div>
    }

    @if (getFileJob(job); as job) {
        <div>
            <b>{{ 'pg-import.file' | locTranslate }}</b>
            <span>{{ job.file }}</span>
        </div>
        <div>
            <b>{{ 'pg-import.resource' | locTranslate }}</b>
            <span>{{ translateResource(job.resource) }}</span>
        </div>
        @if (job.items != null) {
            <div>
                <b>{{ 'pg-import.elements' | locTranslate }}</b>
                <span>
                    <ng-container>
                        {{job.items.length}}
                    </ng-container>
                </span>
            </div>
        }
    }

    @if (getWordPressJob(job); as job) {
        <!--<div>
            <b>{{ 'pg-import.api-url' | locTranslate }}</b>
            <span>{{ job.APIUrl }}</span>
        </div>-->
        <div class="PGImportJob-Items">
            <b>{{ 'pg-import.elements' | locTranslate }}</b>
            <span>
                @if (job.items != null) {
                    <span [innerHTML]="getJobItemListDisplay(job.items)"></span>
                }
            </span>
        </div>
    }


    @if (getDHMJob(job); as job) {
        <div class="PGImportJob-Items">
            <b>{{ 'pg-import.elements' | locTranslate }}</b>
            <span>
                @if (job.items != null) {
                    <span [innerHTML]="getJobItemListDisplay(job.items)"></span>
                }
            </span>
        </div>

        @if (job.items != null) {
            @if(getJobItemListDisplay(job.items, true); as display) {
                <div class="PGImportJob-Items">
                    <b>{{ 'pg-import.elements-secondary' | locTranslate }}</b>
                    <span>
                        <span [innerHTML]="display"></span>
                    </span>
                </div>
            }
        }
    }

    @if (getEPPOIJob(job); as job) {
        <div class="PGImportJob-Items">
            <b>{{ 'pg-import.elements' | locTranslate }}</b>
            <span>
                @if (job.items != null) {
                    <span [innerHTML]="getJobItemListDisplay(job.items)"></span>
                }
            </span>
        </div>
    }

    @if (job.force) {
        <div>
            <b>{{ 'pg-import.with-' + job.force | locTranslate }}</b>
        </div>
    }

    <!--<div *ngIf="job.time">
    <b>{{ 'pg-import.time' | locTranslate }}</b>
    <span>{{ formatDateTime(job.time) }}</span>
    </div>-->

    @if (job.progress) {
        <div>
            @if (getJobTimeBegin(); as time_begin) {
                <div>
                    <b>{{ 'pg-import.progress-time_begin' | locTranslate }}</b><span>{{ formatTime(time_begin) }}</span>
                </div>
            }
            @if (getJobTimeEnd(); as time_end) {
                <div>
                    <b>{{ 'pg-import.progress-time_end' | locTranslate }}</b><span>{{ formatTime(time_end) }}</span>
                </div>
            }
            
            <div class="PGImportJob-Progress-Status-Result">
                @if(getJobResult(); as result) {
                    @if(isJobInitializing()) {
                        <div>{{ 'pg-import.progress-initializing' | locTranslate }}</div>
                    }
                    @else {
                        @for(status of ['success','success_secondary_errors','update','error','progress','waiting','canceled']; track status) {
                            <ng-container *ngTemplateOutlet="jobResultTemplate;context:{ result: result, status: status }"></ng-container>
                        }
                    }
                }
            </div>

            @if (getJobTimeBegin() && !getJobTimeEnd()) {
                <div class="PGImportJob-Progress-Status-Bar progress my-2">
                    <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" [style.transform]="getJobBarTransform()"></div>
                </div>

                <div class="text-end">
                    <button class="btn btn-sm btn-link text-danger p-0" (click)="cancel.emit()">{{ 'pg-import.cancel' | locTranslate }}</button>
                </div>
            }

            <ng-content></ng-content>
        </div>
    }
</div>

<ng-template #jobResultTemplate let-result="result" let-status="status">
    @if(result[status]) {
        <div>
            <button class="btn btn-link btn-block p-0 d-flex justify-content-between" (click)="isStatusFinished(status) ? showDetails[status] = !showDetails[status] : null">
                <div>
                    <i class="fa-regular fa-fw {{ getProgressStatusIcon(status) }} text-{{ getProgressStatusColor(status) }}"></i>
                    <span>{{ result[status] }} {{ 'pg-import.job-status-' + status | locTranslate }}</span>
                </div>
                <div>
                    @if(isStatusFinished(status)) {
                        <i class="fa-regular me-2 fa-chevron-{{ showDetails[status] ? 'up' : 'down' }}"></i>
                    }
                </div>
            </button>
            </div>
            @if (showDetails[status]) {
                @for (progress of job.progress; track progress; let i = $index) {
                    @if(getProgressStatus(progress) == status) { 
                        <div class="PGImportJob-Progress border-start ps-2 my-2">
                            @if (getFileJob(job); as job) {
                                <div>
                                    @if (job.items[i]; as item) {
                                        <pre class="PGImportJob-Progress-Content pb-2 mb-0">{{ job.items[i].src }}</pre>
                                    }
                                </div>
                            }
                            @else {
                                @if (job.items[i]; as item) {
                                    <div> 
                                        <b>{{ 'pg-import.progress-element' | locTranslate }}</b>
                                        <span>{{ translateResource(item.resource) }} - {{ item.id }}</span>
                                        @if(progress.tasks?.main?.element; as element) {
                                            @if (element.name || element.title; as name) {
                                                <span> "{{ name }}"</span>
                                            }
                                        }
                                        @if (progress.secondary) {
                                            <span class="text-muted small"> {{ 'pg-import.progress-secondary' | locTranslate }}</span>
                                        }
                                    </div>
                                }
                            }
                            @if (progress.time_begin) {
                                <div>
                                    <b>{{ 'pg-import.progress-time_begin' | locTranslate }}</b><span>{{ formatTime(progress.time_begin) }}</span>
                                </div>
                            }
                            @if (progress.time_end) {
                                <div>
                                    <b>{{ 'pg-import.progress-time_end' | locTranslate }}</b><span>{{ formatTime(progress.time_end) }}</span>
                                </div>
                            }
                            <div class="PGImportJob-Progress-Status">
                                <b>{{ 'pg-import.progress-status' | locTranslate }}</b>
                                <span class="PGImportJob-Progress-Status-Value">
                                    @if (!progress.time_begin && !progress.time_end) {
                                        <span class="text-muted">{{ 'pg-import.job-status-waiting' | locTranslate }}</span>
                                    }
                                    @if (progress.time_begin && !progress.time_end) {
                                        <span>{{ 'pg-import.job-status-progress' | locTranslate }}</span>
                                        <div class="PGImportJob-Progress-Status-Bar progress">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" [style.transform]="getProgressBarTransform(progress)"></div>
                                        </div>
                                    }
                                    @if (progress.time_end) {
                                        @if (getProgressStatus(progress); as status) {
                                            @if (getProgressStatusIcon(status); as icon) {
                                                <i class="fa-regular fa-fixed {{icon}} text-{{getProgressStatusColor(status)}} me-1"></i>
                                            }
                                            {{ 'pg-import.job-status-' + status | locTranslate }}
                                        }
    
                                        @if (progress.status == 'success') {
                                            <div>
                                                <b>{{ 'pg-import.progress-imported' | locTranslate }}</b><a target="_blank" [href]="getElementURL(progress.tasks.main.resource, progress.tasks.main.element.id)"><i class="fa-regular fa-xs fa-arrow-up-right-from-square me-2"></i>{{ translateResource(progress.tasks.main.resource) }} - {{ progress.tasks.main.element.id }}</a>
                                            </div>
                                        }
                                        @if (progress.message) {
                                            <div>
                                                <small class="ms-1 text-{{ getProgressStatusColor(progress.status) }}">{{ progress.message }}</small>
                                            </div>
                                        }
                                        @if (progress.status == 'error') {
                                            <a class="d-block" (click)="openError(job, i, 'main')" href="javascript:void(0)">
                                                <small>
                                                    <i class="fa-regular fa-circle-exclamation"></i><span class="ms-1">{{ 'pg-import.job-status-error-details' | locTranslate }}</span>
                                                </small>
                                            </a>
                                        }
                                        @if (hasSecondaryErrors(progress)) {
                                            <div>
                                                <span>{{ 'pg-import.job-status-secondary-errors' | locTranslate }}:</span>
                                                <small>
                                                    @for (task of progress.tasks.translations; track task; let j = $index) {
                                                        @if (task.status == 'error') {
                                                            <a class="d-block" (click)="openError(job, i, 'translations', j)" href="javascript:void(0)">
                                                                <i class="fa-regular fa-circle-exclamation"></i><span class="ms-1">{{ task.message }}</span>
                                                            </a>
                                                        }
                                                    }
                                                    @for (task of progress.tasks.files; track task; let j = $index) {
                                                        @if (task.status == 'error') {
                                                            <a class="d-block" (click)="openError(job, i,'files', j)" href="javascript:void(0)">
                                                                <i class="fa-regular fa-circle-exclamation"></i><span class="ms-1">{{ task.message }}</span>
                                                            </a>
                                                        }
                                                    }
                                                </small>
                                            </div>
                                        }

                                    }
                                </span>
                            </div>
                        </div>
                    }
                }
            }
    }
</ng-template>

<ng-template #errorModal>
    <div class="modal-header">
        <h5 class="modal-title">{{ 'pg-import.error-modal-title' | locTranslate }}</h5>
        <button type="button" class="modal-close btn btn-link" (click)="errorModalDismiss()">
            <i class="fa-regular fa-times"></i>
        </button>
    </div>
    <div class="modal-body">
        @if (errorModalLoading) {
            <app-pg-loading></app-pg-loading>
        }
        @if (!errorModalLoading && errorModalResponseData) {
            <div><b>REQUEST</b></div>
            <pre>{{errorModalResponseData.method}} {{errorModalResponseData.url}}</pre>
            @if (errorModalResponseData.body) {
                <pre class="border mt-1 p-1">{{errorModalResponseData.body | json}}</pre>
            }
            <div><b>RESPONSE</b></div>
            <pre>{{errorModalResponseData.statusCode}} - {{errorModalResponseData.statusMessage}}</pre>
            @if (errorModalResponseFile) {
                <iframe class="border mt-1" [src]="errorModalResponseFile | safe:'resourceUrl'"></iframe>
            }
        }
    </div>
</ng-template>
